(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('orderPickView', {
        templateUrl: 'views/components/views/orderPickView/orderPickView.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'orderPickViewService', 'ttGridFactory', function ($stateParams, stateService, orderPickViewService, ttGridFactory) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let orderPickKeyno = $stateParams.orderpick_keyno;

            vm.model = {
                gridBsReady: false,
                edit: {}
            };

            vm.gridBs = new ttGridFactory({
                rememberId: 'w_orderpick_orderpick_sb_grid',
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            });
            
            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadEdit() {
                vm.model.edit = (await orderPickViewService.getEdit({ orderpick_keyno: orderPickKeyno }))[0];

                loadGridBs();
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGridBs() {
                vm.gridBs.dataTask.loadData = {
                    method: 3712,
                    parameters: vm.model.edit
                };

                vm.model.gridBsReady = true;

                if (vm.gridBs.gridfunc !== null) vm.gridBs.gridfunc.read();
            }

            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
            	loadEdit();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
